module.exports = __webpack_public_path__ + "static/img/04.3e7ec05.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/banner/04.jpg
// module id = hp2O
// module chunks = 1